import i18n from "i18n";

const columns = [
    {
      name: 'name',
      pill: false,
      title: i18n.t("name").toUpperCase(),
      mobileTag: false,
    },
    {
      name: 'country',
      pill: false,
      title: i18n.t("country").toUpperCase(),

    },
    {
      name: 'locality',
      pill: false,
      title: i18n.t("municipality").toUpperCase(),

    },
    {
      name: 'email',
      pill: false,
      title: i18n.t("email").toUpperCase(),
      mobileTag: `${i18n.t("email")}:`,

    },
    {
      name: 'phone',
      pill: false,
      title: i18n.t("phone").toUpperCase(),
      mobileTag: `${i18n.t("phone")}:`,

    },
  ];


  export default columns;